import App from './Sketch.svelte';

const app = new App({
	target: document.body,
});

export default app;